import AddUser from "./AddUser";

export default AddUser;